export const CONTENT_BAND_INSET = 'max(96px, calc((100% - 1408px) / 2))';

export const TABLET_DOWN = '@media screen and (max-width: 1024px)';

export const MOBILE_DOWN = '@media screen and (max-width: 599px)';

export const HERO_TABLET_IMAGE = '/images/home-images/home-banner-tab.webp';

export const HERO_MOBILE_IMAGE = '/images/home-images/home-banner-mobile.webp';

export const HEADER_OFFSET = '88px';

export const HERO_MOBILE_UNIT = 'calc(100vw / 430)';

export const WAVE_BAND = '/images/home-images/wave-band.svg';

export const WAVE_DOME = '/images/home-images/wave-dome.svg';
